'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import {
  sortItems
} from 'helpers/matchers';
import {
  getNewStateObject,
  getComponentState
} from './classifier.state';
import {
  autocompleteListItemClassName,
  autocompleteListItemStyle
} from 'helpers/classNameStyles';
import classifierSelector from './classifier.selector';
import Autocomplete from 'components/clarity-ui/inputs/autocomplete';
import OverviewTable from 'components/classifier/classifierOverviewTable.component';
import ClassifierTargetsComponent from './classifierTargets/classifierTargets.component';
import ClassifierPageHeader from './classifierPageHeader.component';
import Loader from 'components/clarity-ui/components/loader';
import _ from 'lodash';
import VideoModal from './classifierTargets/targetResults/videoResults/videoModal.component';

class ClassifierComponent extends React.Component {

  constructor () {
    super();
    this.handleClassifiersAutocompleteOnChange = _.debounce(this.handleClassifiersAutocompleteOnChange, 1000);
  }

  componentWillMount () {
    const stateObject = getNewStateObject(this.props.isFetchingOnMount);
    if (!!this.props.classifier && this.props.classifier.id > 0) {
      browserHistory.push(`/classifiers/${this.props.classifier.id}`);
      _.assign(stateObject, getComponentState(true, {}, stateObject, stateObject, this.props));
    }
    this.setState(stateObject);
  }

  componentDidUpdate (prevProps, prevState) {
    const newState = getComponentState(false, prevProps, prevState, this.state, this.props);

    if (!_.isEmpty(newState)) {
      this.setState(newState);
    }
  }

  handleSliderOnChange (item, position) {
    const { videoResults } = this.state
    const videoIndex = _.find(videoResults, {videoId: item.videoId});

    videoIndex.currentPosition = position;
    this.setState({videoResults: videoResults});
  }

  handleThumbnailOnClick (videoItem) {
    this.setState({ isModalActive: true, modalItem: videoItem });
  }

  handleModalCloseButtonOnClick () {
    this.setState({ isModalActive: false, modalItem: {} });
  }

  /**
  * MTurk Evaluator Section Functions
  */

  /** Handles MTurk Hit Evaluator Save Button Click Function */
  handleSaveHitEvaluatorOnClick () {
    const { mturkEvaluatorState, mturkActiveTab, clfTargetTableRowId } = this.state;
    this.props.saveEvaluator(mturkActiveTab.replace('mturk', ''), mturkEvaluatorState, clfTargetTableRowId);
    this.setState({loading: true});
  }

  /** Handles Hit Evaluator Input Fields On Change */
  handleHitEvaluatorInputOnChange (event) {
    const { id, value, checked } = event.currentTarget;
    const { mturkEvaluatorState } = this.state;

    if (id === 'hitEnabled') {
      mturkEvaluatorState.targetLabel.targetClassifier.hitEnabled = checked;
    } else {
      mturkEvaluatorState[id] = value
    }

    this.setState({mturkEvaluatorState: mturkEvaluatorState});
  }

  /** Handles Tabs Navigation Change */
  handleMTurkNavTabChange (synthEvent) {
    const tabId = synthEvent.currentTarget.id;
    this.props.fetchEvaluator(this.state.targetLabelRowId, tabId.replace('mturk', ''));
    this.setState({mturkActiveTab: tabId, loadingComponent: 'mturkEvaluator'});
  }

  /** Retrieves a weighted label object  */
  getNewWeightedTargetObj () {
    const { labelToAdd } = this.state;
    return {
      labelId: labelToAdd.labelItem.id,
      weight: labelToAdd.labelWeight,
      label: {
        labelType: labelToAdd.labelItem.labelType,
        name: labelToAdd.labelItem.name
      },
      action: 'create'
    };
  }

  /** Handles Save Button Click Function */
  handleSaveWeightedLabelsOnClick () {
    this.props.saveWeightedLabels(this.state.weightedLabels);
    this.setState({loading: true});
  }

  /**
  * Add Labels Function Section
  */

  /** Add Labels Autocomplete Handle On Change Function*/
  handleAddLabelsAutocompleteOnChange (event, value) {
    this.props.fetchLabels(value);
    this.setState({labelAutocompleteInputValue: value});
  }

  /** Add Labels Autocomplete Handle On Select Function*/
  handleAddLabelsAutocompleteSelect (value, item) {
    const labelToAdd = _.assign({}, this.state.labelToAdd, {labelItem: item});
    this.setState({
      labelToAdd: labelToAdd,
      labelAutocompleteInputValue: value
    });
  }

  /** Add Labels Weight Input Function*/
  handleAddLabelWeightOnChange (event) {
    const { value } = event.currentTarget
    const labelWeight = {labelWeight: value};
    if (_.isNaN(parseFloat(value)) || parseInt(value) < 0 || parseInt(value) > 100) {
      _.assign(labelWeight, {error: 'Value must be between 0 - 100'});
    } else if (this.state.labelToAdd.error === 'Value must be between 0 - 100') {
      delete this.state.labelToAdd.error;
    }
    const labelToAdd = _.assign({}, this.state.labelToAdd, labelWeight);
    this.setState({labelToAdd: labelToAdd});
  }

  /** Add Labels Add Button Function*/
  handleAddButtonOnClick () {
    const { weightedLabels, labelToAdd } = this.state;
    const addedlabel = _.find(weightedLabels.weightedClfTargets, {labelId: labelToAdd.labelItem.id});
    if (_.isUndefined(addedlabel)) {
      weightedLabels.weightedClfTargets.push(this.getNewWeightedTargetObj());
    } else {
      addedlabel.weight = labelToAdd.labelWeight;
    }
    this.setState({
      weightedLabels: weightedLabels,
      labelToAdd: {},
      labelAutocompleteInputValue: ''
    });
  }

  /**
  * Filter Classifiers Function Section
  */

  /** Filter Classifiers Handle On Select Function*/
  handleClassifiersAutocompleteSelect(name, item) {
    this.context.router.push(`/classifiers/${item.id}`);
    this.setState({
      isSelectedClassifier: true,
      targetLabels: [],
      filterClassifierAutocompleteValue: '',
      clfTargetTableRowId: 0,
      loading: true
    });
  }

  /** Filter Classifiers Handle On Change Function*/
  handleClassifiersAutocompleteOnChange (event, value) {
    this.setState({filterClassifierAutocompleteValue: value});
    this.props.fetchClassifiers(value);
  }

  /**
  * Weighted Labels Table Section
  */

  /** Remove Table Labels Function */
  handleRemoveWeightedLabelsOnClick (item) {
    const { weightedLabels } = this.state;
    const labelIndex = _.findIndex(weightedLabels.weightedClfTargets, {labelId: item.labelId});
    if (!!item.action && item.action === 'create') {
      _.remove(weightedLabels.weightedClfTargets, (item) => {
        return item.labelId === weightedLabels.weightedClfTargets[labelIndex].labelId;
      });
    } else {
      weightedLabels.weightedClfTargets[labelIndex].action = 'delete';
    }
    this.setState({weightedLabels: weightedLabels});
  }

  /** Edit Table Label Input Weight Function */
  handleWeightInputOnChange (item, synthEvent) {
    const { weightedLabels } = this.state;
    const weightedValue = synthEvent.currentTarget.value;
    const labelIndex = _.findIndex(weightedLabels.weightedClfTargets, {labelId: item.labelId});
    if (!item.action || item.action !== 'create') {
      weightedLabels.weightedClfTargets[labelIndex].action = 'update';
    }
    weightedLabels.weightedClfTargets[labelIndex].weight = weightedValue;

    if (_.isNaN(parseFloat(weightedValue)) || parseInt(weightedValue) < 0 || parseInt(weightedValue) > 100) {
      _.assign(weightedLabels.weightedClfTargets[labelIndex], {error: 'Value must be between 0 - 100'});
    } else if (weightedLabels.weightedClfTargets[labelIndex].error === 'Value must be between 0 - 100') {
      delete weightedLabels.weightedClfTargets[labelIndex].error;
    }

    this.setState({weightedLabels: weightedLabels});
  }

  /**
  * Clf Targets Tab section
  */

  /** Handle Tab on Change function */
  handleNavigationTabChange (synthEvent) {
    const tabId = synthEvent.currentTarget.id,
          turkQaEnabled = !!this.props.turkQaEnabled ? this.props.turkQaEnabled : {},
          newState = {};
    const { clfTargetTableRowId, weightedLabels, targetLabelRowId, mturkActiveTab } = this.state;

    if (tabId === 'resultsTab') {
      this.props.fetchDetectorResults(clfTargetTableRowId);
    } else if (tabId === 'attachedLabelsTab' && clfTargetTableRowId !== weightedLabels.id) {
      this.props.fetchWeightedLabels(clfTargetTableRowId, this.props.classifier.id);
    } else if (tabId === 'mturkTab' && clfTargetTableRowId !== turkQaEnabled.id) {
      _.assign(newState, {loadingComponent: 'mturkEvaluator'})
      this.props.fetchMTurkQaEnabled(clfTargetTableRowId);
      this.props.fetchEvaluator(targetLabelRowId, mturkActiveTab.replace('mturk', ''));
    }
    _.assign(newState, {activeTab: tabId});
    this.setState(newState);
  }

  getFetchCallByTabId (activeTabId) {
    switch (activeTabId) {
      case 'resultsTab':
        return this.props.fetchDetectorResults;
      case 'attachedLabelsTab':
        return this.props.fetchWeightedLabels;
      case 'mturkTab':
      return this.props.fetchMTurkQaEnabled;
    }
  }

  /**
  * Clf Target Label Table Section
  */

  /** Handle Table Row On Click Function */
  handleTargetTableClick (classifierId, clfTargetId, targetLabelId) {
    const { clfTargetTableRowId, targetLabelRowId, activeTab } = this.state;
    const newState = {},
          fetchCall = this.getFetchCallByTabId(activeTab),
          targetLabelTableId = targetLabelRowId === targetLabelId ? 0 : targetLabelId,
          targetId = clfTargetTableRowId === clfTargetId ? 0 : clfTargetId;

    if (clfTargetTableRowId !== clfTargetId) fetchCall(clfTargetId, classifierId);
    else fetchCall(0, 0);

    if (this.state.activeTab !== 'attachedLabelsTab') _.assign(newState, {clfTargetTableRowId: targetId});

    _.assign(newState, {targetLabelRowId: targetLabelTableId, loading:true});
    this.setState(newState);
  }

  renderClassifiersAutocomplete () {
    return (
      <Autocomplete
        inputProps={{className:'InputField-input'}, {placeholder:'Type classifier name'}}
        onChange={this.handleClassifiersAutocompleteOnChange.bind(this)}
        onSelect={this.handleClassifiersAutocompleteSelect.bind(this)}
        value={this.state.filterClassifierAutocompleteValue}
        items={this.props.selectedClassifiers}
        getItemValue={(classifier) => classifier.name}
        shouldItemRender={() => {return true}}
        sortItems={sortItems}
        shouldClear={false}
        renderItem={(classifier, isHighlighted, styles) => (
          <li
            className={autocompleteListItemClassName(isHighlighted)}
            style={autocompleteListItemStyle(isHighlighted, styles)}
            key={classifier.id}
          >{classifier.name}</li>
        )}
      />
    );
  }

  handleTargetLabelsAutocompleteSelect (name, clfTarget) {
    this.handleTargetTableClick(this.props.classifier.id, clfTarget.clfTargetId, clfTarget.targetLabel.id);
    // this.setState({targetLabels: [targetLabel]});
  }

  handleOnTargetLabelsAutocompleteChange (/*synthEvent, value*/) {
    // if (_.isEmpty(value) && this.state.targetLabels.length > 0) this.setState({targetLabels: []});
  }

  renderVideoModal (isModalActive, modalItem) {
    return (
      <VideoModal
        isActive={isModalActive}
        video={modalItem}
        handleCloseOnClick={this.handleModalCloseButtonOnClick.bind(this)} />
    );
  }

  render() {
    const { isSelectedClassifier, loading, labelToAdd, labelAutocompleteInputValue,
      activeTab, clfTargetTableRowId, videoResults, isModalActive, modalItem, boxResults,
      loadingComponent, mturkActiveTab, mturkEvaluatorState } = this.state;
    const classifier = (isSelectedClassifier || !_.isEmpty(this.props.classifier)) && !loading ? this.props.classifier : {};
    const clfTargets = !_.isEmpty(classifier) && !loading ? classifier.clfTargets : [];
    const targetLabels = _.isEmpty(this.state.targetLabels) ? clfTargets : this.state.targetLabels;
    const selectedClassifier = !_.isEmpty(classifier) ? classifier.name : '';
    const selectedClassifierId = !_.isEmpty(classifier) ? classifier.id : '';
    const textDetectorResults = !!this.props.textDetectorResults && this.props.textDetectorResults.length>0 && this.props.textDetectorResults[0].clfTargetId === clfTargetTableRowId ? this.props.textDetectorResults : [];
    const turkQaEnabled = !!this.props.turkQaEnabled ? this.props.turkQaEnabled : {};

    return (
      <div className="EntityList">
        { isModalActive ? this.renderVideoModal(isModalActive, modalItem) : null}
        <Loader loading={loading} />
        <ClassifierPageHeader title="Classifiers" selectedClassifier={selectedClassifier} />
        <div className="BreakLine">
          { this.renderClassifiersAutocomplete() }
        </div>
        <div className="BreakLine">
          <OverviewTable classifier={classifier}/>
        </div>
        <div className="BreakLine">
          <h3>Classifier Target Name</h3>
          <ClassifierTargetsComponent
            activeTab={activeTab}
            classifierId={selectedClassifierId}
            targetLabels={targetLabels}
            filteredLabels={this.props.filteredLabels}
            clfTarget={this.state.weightedLabels}
            selectedClfTargetId={clfTargetTableRowId}
            clfTargets={clfTargets}
            textDetectorResults={textDetectorResults}
            boxDetectorResults={boxResults}
            videoDetectorResults={videoResults}
            labelToAdd={labelToAdd}
            labelAutocompleteInputValue={labelAutocompleteInputValue}
            handleAddLabelWeightOnChange={this.handleAddLabelWeightOnChange.bind(this)}
            handleAddButtonOnClick={this.handleAddButtonOnClick.bind(this)}
            handleLabelsAutocompleteOnChange={this.handleAddLabelsAutocompleteOnChange.bind(this)}
            handleLabelsAutocompleteSelect={this.handleAddLabelsAutocompleteSelect.bind(this)}
            handleRemoveWeightedLabelsOnClick={this.handleRemoveWeightedLabelsOnClick.bind(this)}
            handleWeightInputOnChange={this.handleWeightInputOnChange.bind(this)}
            handleSaveOnClick={this.handleSaveWeightedLabelsOnClick.bind(this)}
            handleTargetTableClick={this.handleTargetTableClick.bind(this)}
            handleTargetLabelsAutocompleteSelect={this.handleTargetLabelsAutocompleteSelect.bind(this)}
            handleOnTargetLabelsAutocompleteChange={this.handleOnTargetLabelsAutocompleteChange.bind(this)}
            handleNavigationTabChange={this.handleNavigationTabChange.bind(this)}
            handleSliderOnChange={this.handleSliderOnChange.bind(this)}
            handleThumbnailOnClick={this.handleThumbnailOnClick.bind(this)}
            handleMTurkNavTabChange={this.handleMTurkNavTabChange.bind(this)}
            handleHitEvaluatorInputOnChange={this.handleHitEvaluatorInputOnChange.bind(this)}
            handleSaveHitEvaluatorOnClick={this.handleSaveHitEvaluatorOnClick.bind(this)}
            pageNotification={this.state.pageNotification}
            turkQaEnabled={turkQaEnabled}
            loadingComponent={loadingComponent}
            mturkActiveTab={mturkActiveTab}
            mturkHitEvaluator={mturkEvaluatorState}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => {
  const getFromSelector = classifierSelector;
  const stateToProps = (state) => {
    return getFromSelector(state);
  };
  return stateToProps;
}

ClassifierComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(mapStateToProps)(ClassifierComponent);



// WEBPACK FOOTER //
// ./src/components/classifier/classifier.component.jsx